/* eslint-disable max-len */
import React from "react";
import { string, number } from "prop-types";

export const TodaysTime = ({ color = "#fff", height = "", width = "" }) => (
  <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
    <g>
      <path
        d="M16 28C12.9333 28 10.2611 26.9833 7.98333 24.95C5.70556 22.9167 4.4 20.3778 4.06667 17.3333H6.8C7.11111 19.6444 8.13889 21.5556 9.88333 23.0667C11.6278 24.5778 13.6667 25.3333 16 25.3333C18.6 25.3333 20.8056 24.4278 22.6167 22.6167C24.4278 20.8056 25.3333 18.6 25.3333 16C25.3333 13.4 24.4278 11.1944 22.6167 9.38333C20.8056 7.57222 18.6 6.66667 16 6.66667C14.4667 6.66667 13.0333 7.02222 11.7 7.73333C10.3667 8.44444 9.24444 9.42222 8.33333 10.6667H12V13.3333H4V5.33333H6.66667V8.46667C7.8 7.04444 9.18333 5.94444 10.8167 5.16667C12.45 4.38889 14.1778 4 16 4C17.6667 4 19.2278 4.31667 20.6833 4.95C22.1389 5.58333 23.4056 6.43889 24.4833 7.51667C25.5611 8.59444 26.4167 9.86111 27.05 11.3167C27.6833 12.7722 28 14.3333 28 16C28 17.6667 27.6833 19.2278 27.05 20.6833C26.4167 22.1389 25.5611 23.4056 24.4833 24.4833C23.4056 25.5611 22.1389 26.4167 20.6833 27.05C19.2278 27.6833 17.6667 28 16 28ZM19.7333 21.6L14.6667 16.5333V9.33333H17.3333V15.4667L21.6 19.7333L19.7333 21.6Z"
        fill={color}
      />
    </g>
  </svg>
);

TodaysTime.propTypes = {
  color: string,
  height: number,
  width: number,
};

export const TodaysTV = ({ color = "#fff", height = "", width = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.014 24"
    enableBackground="new 0 0 24.014 24"
    xmlSpace="preserve"
    height={height}
    width={width}
  >
    <path
      fill={color}
      d="M6.531,0.023c0.141-0.031,0.288-0.031,0.429,0C7.163,0.121,7.348,0.252,7.509,0.41
                c0.292,0.267,0.585,0.533,0.878,0.8c0.115,0.1,0.234,0.2,0.351,0.3c0.071,0.087,0.155,0.162,0.249,0.223
                c0.227,0.21,0.451,0.423,0.681,0.63c0.386,0.346,0.776,0.689,1.164,1.034s0.763,0.679,1.144,1.019c0.064,0.063,0.1,0,0.134-0.034
                c0.533-0.478,1.065-0.956,1.594-1.435c0.439-0.4,0.877-0.8,1.314-1.2c0.095-0.07,0.183-0.151,0.261-0.24
                c0.19-0.167,0.383-0.333,0.571-0.5c0.229-0.206,0.455-0.416,0.682-0.625c0.09-0.075,0.177-0.156,0.272-0.226
                c0.325-0.253,0.793-0.194,1.046,0.13c0.031,0.041,0.059,0.084,0.081,0.131c0.015,0.028,0.032,0.055,0.049,0.082
                c0.033,0.151,0.033,0.307,0,0.458c-0.06,0.145-0.148,0.276-0.26,0.386c-0.059,0.054-0.14,0.085-0.176,0.163l-1.406,1.256
                c-0.458,0.411-0.915,0.823-1.37,1.237c-0.153,0.138-0.3,0.28-0.475,0.44h6.7c0.328,0.017,0.656-0.006,0.985,0.023
                c0.984,0.103,1.786,0.836,1.977,1.807c0.047,0.412,0.065,0.827,0.053,1.242v11.982c-0.009,0.374,0.009,0.748-0.036,1.12
                l-0.108,0.385c-0.14,0.335-0.349,0.637-0.615,0.885c-0.225,0.188-0.479,0.341-0.751,0.451c-0.3,0.089-0.611,0.13-0.924,0.122
                c-0.159-0.007-0.317,0-0.476,0c-0.037,0-0.1-0.027-0.1,0.054c0,0.447-0.008,0.894,0,1.341c0,0.114-0.031,0.149-0.145,0.144
                c-0.2-0.009-0.4,0-0.6,0c-0.155-0.462-0.314-0.923-0.461-1.388c-0.016-0.099-0.109-0.167-0.208-0.151c-0.001,0-0.001,0-0.002,0
                c-2.992,0-5.984,0-8.977,0c-2.067,0-4.133,0-6.2,0c-0.056,0-0.133-0.037-0.163,0.054c-0.153,0.456-0.309,0.912-0.458,1.37
                c-0.027,0.084-0.064,0.117-0.153,0.114c-0.21-0.006-0.42,0-0.631,0l-0.007-1.482c0-0.09-0.072-0.052-0.112-0.052
                c-0.251,0-0.5,0-0.754-0.006c-0.504-0.015-0.985-0.21-1.358-0.55c-0.46-0.388-0.737-0.951-0.762-1.552
                c-0.01-0.151-0.016-0.3-0.016-0.451c0-4.368,0-8.735,0-13.1c-0.017-0.467,0.108-0.929,0.357-1.324
                c0.249-0.382,0.606-0.681,1.026-0.859c0.305-0.116,0.63-0.173,0.956-0.169c0.224-0.009,0.448,0,0.671,0h3.1h1.394h2.236
                c-0.067-0.063-0.1-0.1-0.146-0.137c-0.698-0.627-1.398-1.253-2.1-1.88C7.132,2.116,6.776,1.804,6.421,1.49
                c-0.169-0.136-0.307-0.307-0.406-0.5c-0.048-0.16-0.048-0.33,0-0.49C6.119,0.28,6.304,0.109,6.531,0.023z M8.989,20.95h4.524h0.055
                c2.728,0,5.456,0,8.183,0c0.407,0.01,0.746-0.312,0.756-0.719c0-0.016,0-0.031,0-0.047c0-4.487,0-8.973,0-13.46
                c0.002-0.059-0.004-0.118-0.016-0.176c-0.082-0.373-0.427-0.629-0.808-0.6H12.06c-0.52,0-1.041,0-1.562,0H7.537
                c-0.328,0-0.656,0-0.984,0h-3.54h-0.8C1.841,5.969,1.54,6.257,1.502,6.627c-0.006,0.292,0,0.584,0,0.876
                c0,0.045-0.005,0.091-0.005,0.136V19.42c0,0.269,0,0.538,0,0.808c0.015,0.387,0.325,0.697,0.712,0.711c0.265,0.005,0.53,0,0.794,0
                h5.978L8.989,20.95z"
    />
    <path
      fill={color}
      d="M8.989,19.5l-1.481-0.028H7.371c-0.02-0.009-0.041-0.016-0.063-0.02L6,19.417
                c-0.091,0-0.182,0.005-0.272,0c-0.412-0.034-0.824-0.072-1.236-0.108c-0.314-0.05-0.632-0.08-0.946-0.133
                c-0.134-0.009-0.243-0.111-0.262-0.244c-0.086-0.373-0.138-0.753-0.157-1.136c-0.05-0.7-0.077-1.393-0.1-2.091
                C2.995,14.576,3.01,13.448,3.01,12.32c0-0.593,0.01-1.187,0.033-1.78c0.019-0.515,0.063-1.028,0.1-1.542
                c0.015-0.342,0.071-0.681,0.166-1.01C3.323,7.915,3.383,7.86,3.457,7.853c0.346-0.049,0.691-0.105,1.038-0.141
                c0.6-0.061,1.208-0.1,1.814-0.117c0.533-0.017,1.066-0.035,1.6-0.059C8.278,7.52,8.648,7.53,9.017,7.511
                c0.172,0,0.345,0.007,0.517,0c0.322-0.006,0.644,0.013,0.965-0.014c0.5,0.024,1.005,0.013,1.507,0.01
                c0.452,0.012,0.9,0.021,1.355,0.034c0.588,0.018,1.177,0.027,1.764,0.062c0.739,0.045,1.479,0.093,2.212,0.21
                c0.325,0.051,0.371,0.084,0.424,0.4c0.074,0.45,0.115,0.9,0.146,1.357c0.056,0.857,0.064,1.714,0.086,2.571s0.017,1.69,0.01,2.534
                c-0.005,0.689-0.019,1.378-0.053,2.066c-0.02,0.683-0.083,1.364-0.19,2.039c-0.021,0.089-0.047,0.176-0.077,0.262
                c-0.025,0.087-0.1,0.1-0.171,0.115c-0.489,0.086-0.982,0.136-1.477,0.178c-0.449,0.038-0.9,0.061-1.348,0.094
                c-0.285,0.031-0.572,0.042-0.858,0.035c-0.123-0.008-0.246,0-0.37,0.005l-1.453,0.027l-1.508,0.006L8.989,19.5z M13.513,9.053
                c-0.5-0.022-1.005-0.042-1.508-0.03c-0.5-0.028-1.005-0.031-1.508-0.018c-0.456-0.007-0.912,0-1.368,0.009
                C8.152,9.027,7.177,9.05,6.201,9.098C5.709,9.121,5.219,9.159,4.728,9.187c-0.078,0.005-0.1,0.033-0.1,0.106
                c-0.067,0.622-0.081,1.247-0.1,1.87c-0.021,0.821-0.016,1.643-0.012,2.464c0,0.94-0.02,1.881,0.031,2.821
                c0.023,0.423,0.032,0.847,0.077,1.269c0.008,0.072,0.024,0.1,0.1,0.107c0.773,0.042,1.546,0.1,2.32,0.131
                c1.109,0.042,2.219,0.042,3.328,0.04c0.543,0,1.087,0,1.63-0.008c0.5,0.013,1.006,0,1.508-0.028
                c0.495,0.008,0.988-0.032,1.481-0.059c0.44-0.026,0.88-0.053,1.32-0.078c0.062,0,0.074-0.034,0.076-0.087
                c0.017-0.409,0.068-0.816,0.058-1.226c0.049-0.5,0.016-1.006,0.045-1.509l0.008-1.508l-0.007-1.481
                c-0.006-0.317-0.012-0.634-0.019-0.951c0.009-0.186,0-0.373-0.027-0.557c0.01-0.406-0.043-0.81-0.058-1.216
                c0-0.059-0.021-0.094-0.086-0.1c-0.437-0.022-0.872-0.075-1.31-0.081C14.501,9.078,14.008,9.054,13.513,9.053L13.513,9.053z"
    />
    <path
      fill={color}
      d="M21.001,11.207c0,0.059,0,0.119,0,0.178c0.01,0.305-0.229,0.561-0.534,0.571
                c-0.012,0-0.024,0-0.036,0c-0.1,0-0.192,0-0.288,0c-0.309,0.038-0.59-0.182-0.628-0.492c-0.002-0.017-0.003-0.034-0.004-0.05
                c-0.053-0.234-0.023-0.478,0.083-0.693c0.095-0.162,0.267-0.262,0.455-0.265c0.182-0.019,0.366-0.012,0.546,0.022
                c0.219,0.063,0.378,0.254,0.4,0.481c0,0.082,0,0.165,0,0.247L21.001,11.207z"
    />
    <path
      fill={color}
      d="M21.001,14.208c0.023,0.164-0.004,0.33-0.078,0.478c-0.088,0.142-0.234,0.238-0.4,0.261
                c-0.176,0.029-0.354,0.029-0.53,0c-0.197-0.021-0.365-0.15-0.435-0.335c-0.105-0.271-0.1-0.572,0.013-0.84
                c0.079-0.192,0.268-0.316,0.476-0.31c0.128,0,0.257,0.006,0.384,0c0.305-0.009,0.56,0.231,0.569,0.537c0,0.01,0,0.021,0,0.031
                C20.997,14.089,20.997,14.149,21.001,14.208z"
    />
  </svg>
);

TodaysTV.propTypes = {
  color: string,
  height: number,
  width: number,
};

export const TodaysDefault = ({ color = "#fff", height = "", width = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
    height={height}
    width={width}
  >
    <path
      fill={color}
      d="M2,6.25C2,5.559,2.559,5,3.25,5h15c0.691,0,1.25,0.559,1.25,1.25S18.941,7.5,18.25,7.5h-15
	C2.559,7.5,2,6.941,2,6.25z M4.5,12.5c0-0.691,0.559-1.25,1.25-1.25h15c0.691,0,1.25,0.559,1.25,1.25s-0.559,1.25-1.25,1.25h-15
	C5.059,13.75,4.5,13.191,4.5,12.5z M19.5,18.75c0,0.691-0.559,1.25-1.25,1.25h-15C2.559,20,2,19.441,2,18.75s0.559-1.25,1.25-1.25
	h15C18.941,17.5,19.5,18.059,19.5,18.75z"
    />
  </svg>
);

TodaysDefault.propTypes = {
  color: string,
  height: number,
  width: number,
};
